import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Drawer from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Drawer';
import { useNavigationDrawerContext } from 'Views/Onboarding/Contexts/NavigationDrawerContext';
import NavigationDrawerContent from 'Views/Onboarding/Components/NavigationDrawerContent';
import { useNewClientContext } from 'Context/NewClientContext';
import useNavigationDrawer from './useNavigationDrawer';

const styles = theme => ({
  root: {},
  drawerPaper: {
    borderTopRightRadius: theme.radius.sm,
    borderBottomRightRadius: theme.radius.sm,
    width: '90%',
    minWidth: 320,
    maxWidth: 500,
  },
});

const NavigationDrawer = ({
  className,
  classes,
}) => {
  const { clientResource } = useNewClientContext();
  const {
    showNavigation,
    handleHideNavigation,
    navigationResource,
  } = useNavigationDrawerContext();
  const { handleClickCard } = useNavigationDrawer();

  return (
    <Drawer
      className={classNames(classes.root, className)}
      anchor="left"
      open={showNavigation}
      ModalProps={{ onBackdropClick: handleHideNavigation }}
      PaperProps={{ className: classes.drawerPaper }}
    >
      <NavigationDrawerContent
        toggleDrawer={handleHideNavigation}
        clientResource={clientResource}
        navigationResource={navigationResource}
        onCardClick={handleClickCard}
      />
    </Drawer>
  );
};

NavigationDrawer.defaultProps = {
  className: '',
};

NavigationDrawer.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(NavigationDrawer);
